import { render, staticRenderFns } from "./AnnotatedContent.vue?vue&type=template&id=5cf3e040&scoped=true&"
import script from "./AnnotatedContent.vue?vue&type=script&lang=js&"
export * from "./AnnotatedContent.vue?vue&type=script&lang=js&"
import style0 from "./AnnotatedContent.vue?vue&type=style&index=0&id=5cf3e040&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf3e040",
  null
  
)

export default component.exports